export enum FilterType {
  COMBINED,
  INDIVIDUAL,
  RANGE
}